/** The platform operator's own pages: every organisation at once. */
export const PLATFORM_PATH = '/platform'
